/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Rail_Packs_BodyInputs */

const en_platform_rail_packs_body = /** @type {(inputs: Platform_Rail_Packs_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session passes that count themselves down, and who owes you at a glance.`)
};

const pl_platform_rail_packs_body = /** @type {(inputs: Platform_Rail_Packs_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakiety wejść, które same się zużywają, i od razu widać, kto zalega.`)
};

/**
* | output |
* | --- |
* | "Session passes that count themselves down, and who owes you at a glance." |
*
* @param {Platform_Rail_Packs_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_rail_packs_body = /** @type {((inputs?: Platform_Rail_Packs_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Rail_Packs_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_rail_packs_body(inputs)
	return en_platform_rail_packs_body(inputs)
});